import { render } from "./CategoryBigFeatureArticle.vue?vue&type=template&id=65525524"
import script from "./CategoryBigFeatureArticle.vue?vue&type=script&lang=js"
export * from "./CategoryBigFeatureArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__